import StepsChart from './steps-chart';

export default StepsChart;
